var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.001,
    height: 14,
    viewBox: "0 0 14.001 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bank_1_",
    "data-name": "bank (1)",
    d: "M14,13.415a.583.583,0,0,1-.583.583H.583a.583.583,0,0,1,0-1.167H13.415A.583.583,0,0,1,14,13.415ZM.169,4.988a1.425,1.425,0,0,1,.089-1.5,2.751,2.751,0,0,1,.973-.875L5.607.339a3.018,3.018,0,0,1,2.785,0l4.375,2.279a2.751,2.751,0,0,1,.973.875,1.425,1.425,0,0,1,.089,1.5,1.583,1.583,0,0,1-1.409.843h-.17V10.5h.583a.583.583,0,0,1,0,1.167H1.166a.583.583,0,0,1,0-1.167h.583V5.832h-.17a1.583,1.583,0,0,1-1.41-.845ZM2.916,10.5h1.75V5.832H2.916ZM5.832,5.832V10.5H8.166V5.832Zm5.25,0H9.332V10.5h1.75ZM1.2,4.447a.418.418,0,0,0,.376.219h10.84a.418.418,0,0,0,.376-.219.264.264,0,0,0-.014-.292,1.575,1.575,0,0,0-.554-.5L7.853,1.372a1.853,1.853,0,0,0-1.707,0L1.771,3.651a1.582,1.582,0,0,0-.554.5.264.264,0,0,0-.015.291Z",
    transform: "translate(0.002 0.002)",
    fill: "#626984"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBuilding);
export default __webpack_public_path__ + "static/media/bank-building.c1fe9dc9c2a9bddcb6fcc9c735a42266.svg";
export { ForwardRef as ReactComponent };